import React, {useContext} from 'react'
import {
    TableRow,
    TableHeaderCell,
    TableHeader,
    TableCell,
    TableBody,
    Table, Label, TableFooter, Dropdown, Pagination, Icon,
} from 'semantic-ui-react'
import {IRequest} from "../../../App/models/Request";
import RequestControl from "./RequestControl";
import {RootStoreContext} from "../../../App/stores/RootStore";
import {observer} from "mobx-react-lite";

const pagingOptions = [
    {
        text: '1',
        value: 1
    },
    {
        text: '5',
        value: 5
    },
    {
        text: '10',
        value: 10
    },
    {
        text: '25',
        value: 25
    },
    {
        text: '50',
        value: 50
    }
]


const RequestListTable: React.FC = () => {
    const rootStore = useContext(RootStoreContext)
    const {requests, requestCount, limit, sortOrder, sortBy, setSort, setLimit, page, setPage, loadTableRequests, totalPages} = rootStore.requestStore;



    const handleGetNext = async (page:number) => {
        // setLoadingNext(true);
        setPage(page);
        await loadTableRequests();//.then(() => setLoadingNext(false))
    }

    const toggleSort = async (column:string)=>{
        setSort(sortOrder==='ascending'?'descending':'ascending', column)
        await loadTableRequests()
    }

    return (
        <Table sortable celled >
            <TableHeader>
                <TableRow>
                    <TableHeaderCell width={1}>
                        *
                    </TableHeaderCell>
                    <TableHeaderCell

                        sorted={sortBy === 'requestCaseID' ? sortOrder : undefined}
                        onClick={async () => {
                            await toggleSort('requestCaseID')
                        }
                        }
                    >
                        Case Id
                    </TableHeaderCell>


                    <TableHeaderCell
                        sorted={sortBy === 'provider' ? sortOrder : undefined}
                        onClick={async () => {
                            await toggleSort('provider')
                            }
                        }
                    >
                        Provider
                    </TableHeaderCell>
                    <TableHeaderCell
                        sorted={sortBy === 'serviceType' ? sortOrder : undefined}
                        onClick={async () => {
                            await toggleSort('serviceType')
                        }
                        }
                    >
                        Service Type
                    </TableHeaderCell>
                    <TableHeaderCell
                        sorted={sortBy === 'transactionType' ? sortOrder : undefined}
                        onClick={async () => {
                            await toggleSort('transactionType')
                        }
                        }
                    >
                        Transaction Type
                    </TableHeaderCell>
                    <TableHeaderCell
                        sorted={sortBy === 'registrationRequestId' ? sortOrder : undefined}
                        onClick={async () => {
                            await toggleSort('registrationRequestId')
                        }
                        }
                    >
                        Registration Request Id
                    </TableHeaderCell>
                    <TableHeaderCell
                        sorted={sortBy === 'requestDate' ? sortOrder : undefined}
                        onClick={async () => {
                            await toggleSort('requestDate')
                        }
                        }
                    >
                        Request Age
                    </TableHeaderCell>
                    <TableHeaderCell
                        sorted={sortBy === 'serviceId' ? sortOrder : undefined}
                        onClick={async () => {
                            await toggleSort('serviceId')
                        }
                        }
                    >
                        Service Id
                    </TableHeaderCell>
                    <TableHeaderCell>
                        status
                    </TableHeaderCell>
                    {/*<TableHeaderCell>*/}
                    {/*    recommendation By*/}
                    {/*</TableHeaderCell>*/}
                    {/*<TableHeaderCell>*/}
                    {/*    decision By*/}
                    {/*</TableHeaderCell>*/}
                    <TableHeaderCell>
                        Prev Reviewers
                    </TableHeaderCell>
                    <TableHeaderCell>
                        Current Reviewer
                    </TableHeaderCell>
                    {/*<TableHeaderCell*/}
                    {/*    sorted={sortBy === 'documentDate' ? sortOrder : undefined}*/}
                    {/*    onClick={async () => {*/}
                    {/*        await toggleSort('documentDate')*/}
                    {/*    }*/}
                    {/*    }*/}
                    {/*>*/}
                    {/*    document Date*/}
                    {/*</TableHeaderCell>*/}

                </TableRow>
            </TableHeader>
            <TableBody>
                {requests.map((request: IRequest) => (
                    <TableRow key={request.id}>
                        <TableCell>
                            <RequestControl request={request} />
                        </TableCell>
                        <TableCell>
                            {request.requestCaseID}
                            {(
                                request.spanishRequest ?
                                    <Label color="yellow">Spanish</Label> :
                                    ""
                            )}
                        </TableCell>
                        <TableCell>{request.provider}</TableCell>
                        <TableCell>{request.serviceType}</TableCell>
                        <TableCell>{request.transactionType}</TableCell>
                        <TableCell>{request.registrationRequestID}</TableCell>
                        <TableCell>{request.age.toString() + " hours"}</TableCell>
                        <TableCell>{request.tdn}</TableCell>
                        <TableCell>{request.status}</TableCell>
                        {/*<TableCell>{request.recommendationBy}</TableCell>*/}
                        {/*<TableCell>{request.decisionBy}</TableCell>*/}
                        <TableCell>{`${request.recommendationBy ?? ""}${!!request.decisionBy ? ", " + request.decisionBy: ""}`}</TableCell>
                        <TableCell>{request.currentRequestReviewerName ?? ""}</TableCell>
                        {/*<TableCell><Moment format={'MMM D YYYY'} date={request.documentDate} /></TableCell>*/}
                    </TableRow>

                ))}

            </TableBody>
            <TableFooter fullWidth>
                <TableRow >
                    <TableHeaderCell >
                        <Label> total records: {requestCount}</Label>
                        <Label>Records per Page</Label>

                        <Dropdown
                            className='icon'
                            item
                            placeholder=''
                            clearable={false}
                            fluid={ false}
                            selection
                            options={pagingOptions}
                            onChange={async (pageOption) => {
                                setPage(0)
                                setLimit(parseInt(pageOption.currentTarget.innerText))
                                await loadTableRequests()
                            }}
                            value={limit}

                        />
                    </TableHeaderCell>

                    <TableHeaderCell colSpan='12'>
                        <Pagination
                            defaultActivePage={page}
                            onPageChange={async (e,d)=>{
                                    let newPage = d.activePage as number
                                    await handleGetNext(newPage-1)
                            }}
                            ellipsisItem={{ content: <Icon name='ellipsis horizontal' />, icon: true }}
                            firstItem={{ content: <Icon name='angle double left' />, icon: true }}
                            lastItem={{ content: <Icon name='angle double right' />, icon: true }}
                            prevItem={{ content: <Icon name='angle left' />, icon: true }}
                            nextItem={{ content: <Icon name='angle right' />, icon: true }}
                            totalPages={totalPages}
                        />
                    </TableHeaderCell>
                </TableRow>
            </TableFooter>
        </Table>
    )
}
export default observer(RequestListTable)